<template>
    <div  class="d-block w-100 text-center">
        <font-awesome-icon
                @click="click"
                :icon="params.icon"
                :class="params.class"
                :size="params.size ? params.size : 'md'"
        >
        </font-awesome-icon>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    async click() {
      if (!this.params.onClick) {
        return;
      }

      await this.params.onClick();
    },
  },
});
</script>
